import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as DashboardIcon } from "../../assets/icons/dashboardIcon.svg";
import { ReactComponent as MainPanelIcon } from "../../assets/icons/mainPanelIcon.svg";
import { ReactComponent as CoursesIcon } from "../../assets/icons/coursesIcon.svg";
import { ReactComponent as TeachersIcon } from "../../assets/icons/teachersIcon.svg";
import { ReactComponent as StudentsIcon } from "../../assets/icons/studentsIcon.svg";
import { ReactComponent as AdvertisingIcon } from "../../assets/icons/advertising.svg";
import { ReactComponent as TableIcon } from "../../assets/icons/tableIcon.svg";
import { ReactComponent as EventIcon } from "../../assets/icons/sidebar/events.svg";
// import { ReactComponent as SalaryIcon } from "../../assets/icons/salaryIcon.svg";
import { ReactComponent as ExpensesIcon } from "../../assets/icons/expensenIcon.svg";
import { ReactComponent as IncomesIcon } from "../../assets/icons/incomesIcon.svg";
import { ReactComponent as FeedBacksIcon } from "../../assets/icons/sidebar/feedbacks-icon.svg";
import { ReactComponent as AdminIcon } from "../../assets/icons/sidebar/users-01.svg";
import { ReactComponent as GroupIcon } from "../../assets/icons/sidebar/group-svgrepo-com.svg";
import { ReactComponent as RoomIcon } from "../../assets/icons/room-icon.svg";
import { ReactComponent as CareerIcon } from "../../assets/icons/sidebar/work-case-filled-svgrepo-com (1).svg";
import { ReactComponent as SyllabusIcon } from "../../assets/icons/sidebar/syllabus-svgrepo-com.svg";
import { ReactComponent as DiplomaIcon } from "../../../src/assets/icons/sidebar/diploma.svg";
import { ReactComponent as SalesIcon } from "../../assets/icons/sidebar/sales.svg";
import { ReactComponent as ReportIcon } from "../../assets/icons/sidebar/report.svg";
import { ReactComponent as SalaryIcon } from "../../assets/icons/salary.svg";
import { ReactComponent as QuarterlyPlan } from "../../assets/icons/quarterly-plan.svg";
import { ReactComponent as ContractTypeIcon } from "../../assets/icons/sidebar/contract-type.svg";
import { ReactComponent as CompanyIcon } from "../../assets/icons/sidebar/company.svg";

import {
  WEEKS_BETWEEN_SELECTED_DATES_ACTION_TYPE,
  MAIN_PAGE_TYPE_ACTION_TYPE,
  MODAL_LESSON_ACTION_TYPE,
  DROPDOWN_ERROR_TYPE,
} from "../../redux/actions-type";

export function useCustomHook() {
  const dispatch = useDispatch();
  const startWeek = new Date();
  startWeek.setDate(
    startWeek.getDate() -
      (startWeek.getDay() === 0 ? 7 : startWeek.getDay()) +
      1,
  );

  const { dashboardweek } = useSelector((state) => state.dashboardData);
  startWeek.setHours(0, 0, 0, 0);
  const endWeek = new Date();
  endWeek.setDate(startWeek.getDate() + 6);
  endWeek.setHours(0, 0, 0, 0);
  const weeksArr = ["", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş.", "B."];
  const weeksArrFullName = [
    "Bazar",
    "Bazar ertəsi",
    "Çərşənbə axşamı",
    "Çərşənbə",
    "Cümə axşamı",
    "Cümə",
    "Şənbə",
  ];

  const lessonHours = dashboardweek;

  const lessonStatusList = [
    { name: "Gözləyir", key: "unviewed" },
    { name: "Keçirilib", key: "confirmed" },
    { name: "Ləğv edilib", key: "cancelled" },
  ];

  const mentorHourList = [
    { name: "Keçirilib", key: "confirmed" },
    { name: "Keçirilməyib", key: "cancelled" },
  ];
  const fineTypeList = [
    { name: "Şifahi xəbərdarlıq", key: "verbalWarning" },
    { name: "Yazılı xəbərdarlıq", key: "writtenWarning" },
    { name: "Töhmət", key: "rebuke" },
    { name: "Şiddətli töhmət", key: "severeRebuke" },
  ];
  const whereComingList = [
    { name: "İnstagram Sponsorlu", key: "instagramSponsor" },
    { name: "İnstagram standart", key: "instagramStandart" },
    { name: "İnstruktor Tövsiyyəsi", key: "instructorRecommend" },
    { name: "Dost Tövsiyyəsi", key: "friendRecommend" },
    { name: "Sayt", key: "site" },
    { name: "Tədbir", key: "event" },
    { name: "AİESEC", key: "AİESEC" },
    { name: "PO COMMUNİTY", key: "POCOMMUNİTY" },
    { name: "Köhnə tələbə", key: "oldStudent" },
    { name: "Staff tövsiyyəsi", key: "staffRecommend" },
    { name: "SMS REKLAMI", key: "smsAd" },
    { name: "PROMOKOD", key: "promocode" },
    { name: "Resale", key: "resale" },
    { name: "Whatsapp", key: "whatsapp" },
    { name: "Facebook", key: "facebook" },
    { name: "Zəng", key: "call" },
    { name: "Digər", key: "other" },
  ];

  const salesTypeList = [
    { name: "B2B", key: "B2B" },
    { name: "B2C", key: "B2C" },
    { name: "B2G", key: "B2G" },
  ];

  const studentStatusList = [
    { name: "Yığılan", key: "waiting" },
    { name: "Davam edir", key: "continue" },
    { name: "Məzun", key: "graduate" },
    { name: "Dondurdu (Bunu artıq işlətmirik)", key: "freeze" },
    { name: "Xitam", key: "stopped" },
    { name: "Borclu Məzun", key: "debtor-graduate" },
    { name: "Transfer", key: "transfer" },
  ];

  const whereForDate = [
    { key: "forSales", name: "Satış tarixi" },
    { key: "forConsultation", name: "Konsultasiya tarixi" },
    { key: "forContactDate", name: "Əlaqə  tarixi" },
  ];
  const whereSendList = [
    { name: "Satış", key: "sale" },
    { name: "Technest İnside", key: "technestInside" },
    { name: "Dövlət Məşğulluq Agentliyi", key: "DMA" },
    { name: "Azərbaycan Respublikası Mədəniyyət Nazirliyi", key: "ARMN" },
    { name: "Təhsilin İnkişafı Fondu", key: "TIF" },
    { name: "Azərbaycan Respublikası Elm və Təhsil Nazirliyi", key: "ARETN" },
    { name: "Technest university", key: "technestUniversity" },
    { name: "Future leaders", key: "futureLeaders" },
    { name: "Code for Future", key: "codeForFuture" },
    { name: "Digər", key: "other" },
  ];
  const personaList = [
    { name: "Həvəsli", key: "enthusiastic" },
    { name: "Narazı", key: "dissatisfied" },
    { name: "Müşahidəçi", key: "contractor" },
    { name: "Demaqoq", key: "demagog" },
    { name: "Ekstravert", key: "extrovert" },
    { name: "İntrovert", key: "introvert" },
    { name: "Ailəcanlı", key: "familyFriendly" },
  ];
  const discountReasonList = [
    { name: "Teknest", key: "technest" },
    { name: "Tələbə plus kartı", key: "plus-card" },
    { name: "Digər", key: "other" },
  ];
  const toBeConfirmedList = [
    {
      name: "Təstiqlənməli",
      key: "to-be-confirmed",
    },
    {
      name: "Təstiqlənmiş",
      key: "confirmed",
    },
  ];
  const constStatusList = [
    {
      name: "İlkin zəng ediləcək",
      key: "new-lead",
      isActive: true,
      dateField: "contactDate",
    },
    {
      name: "Vatsap mesajı göndəriləcək",
      key: "ws-message",
      isActive: true,
      dateField: "wsMessageDate",
    },
    {
      name: "İlıq zəng ediləcək",
      key: "warm-call",
      isActive: true,
      dateField: "warmCallDate",
    },
    {
      name: "Soyuq zəng ediləcək",
      key: "cold-call",
      isActive: true,
      dateField: "coldCallDate",
    },
    {
      name: "Buz zəng ediləcək",
      key: "ice-call",
      isActive: true,
      dateField: "iceCallDate",
    },
    {
      name: "Konsultasiya təyin olundu",
      key: "appointed",
      isActive: true,
      dateField: "constDate",
    },
    {
      name: "Konsultasiya təyin olundu (gəlmədi)",
      key: "appointed-but-not-come",
      isActive: true,
      dateField: "constDate",
    },
    { name: "Satıldı", key: "sold", isActive: true, dateField: "salesDate" },
    {
      name: "İmtina",
      key: "cancelled",
      isActive: true,
      dateField: "cancelledDate",
    },
    { name: "Düşünür (köhnə)", key: "thinks", isActive: false },
    { name: "Zəngi açmadı (köhnə)", key: "not-open-call", isActive: false },
    { name: "Zəng çatmır (köhnə)", key: "call-missing", isActive: false },
    {
      name: "Whatsappda məlumat 1 (köhnə)",
      key: "whatsapp_info",
      isActive: false,
    },
    {
      name: "Whatsappda məlumat 2 (köhnə)",
      key: "whatsapp_info_2",
      isActive: false,
    },
    {
      name: "Whatsappda məlumat 3 (köhnə)",
      key: "whatsapp_info_3",
      isActive: false,
    },
  ];
  const cancelReasonList = [
    { name: "Maddi", key: "financial" },
    { name: "Vaxt Uyğunsuzluğu", key: "timeMismatch" },
    { name: "Təlimçi seçimi", key: "teacherSelection" },
    { name: "Qərarsızlıq", key: "indecision" },
  ];
  const knowledgeList = [
    { name: "Ekspert", key: "master" },
    { name: "Yaxşı", key: "good" },
    { name: "Orta", key: "normal" },
    { name: "Zəif", key: "weak" },
    { name: "Sıfır", key: "zero" },
  ];
  const paymentTypeList = [
    // { name: "Tam ödəniş", key: 1 },
    // { name: "Dərs müddətində", key: "duringLesson" },
    // { name: "11 hissəli", key: "2part" },

    { name: "Tam", key: 1 },
    { name: "Tədris müddəti", key: 2 },
    { name: "10 hissəli", key: 3 },

    // { name: "Seçim yoxdur", key: "noChoice" },
    // { name: "Kredit Kart Birbaşa", key: "creditCardDirect" },
    // { name: "Kredit Kart 10 ay", key: "creditCard10Months" },
    // { name: "Kredit kart hissəli", key: "creditCardInstallment" },
    // { name: "Teknest 70%", key: "technest70" },
    // { name: "Teknest 90%", key: "technest90" },
    // { name: "Teknest 100%", key: "technest100" },
  ];
  const tuitionFeeHeadList = [
    { key: "groupNumber", title: "Qrup Nömrəsi" },
    { key: "instructor", title: "İnstruktor" },
    { key: "status", title: "Status" },
    { key: "contractType", title: "Müqavilə növü" },
    { key: "price", title: "Məbləğ" },
    { key: "discount", title: "Endirim %" },
    { key: "finalPrice", title: "Yekun Məbləğ" },
    { key: "amountPaid", title: "Ödənilmiş məbləğ" },
    { key: "remainder", title: "Qalıq" },
    { key: "studentName", title: "Tələbənin adı" },
    { key: "fin", title: "Fin kodu" },
    { key: "phone", title: "Nömrəsi" },
    { key: "startDate", title: "Dərs baş. tarixi" },
  ];
  const generalProfileList = [
    {
      id: 1,
      name: "İdarəetmə paneli",
      key: "dashboard",
      icon: <DashboardIcon />,
    },
    { id: 2, name: "Hesabatlar", key: "report", icon: <ReportIcon /> },
    { id: 3, name: "Cədvəl", key: "lessonTable", icon: <TableIcon /> },
    { id: 4, name: "Tələbələr", key: "students", icon: <StudentsIcon /> },
    { id: 5, name: "Şirkətlər", key: "company", icon: <CompanyIcon /> },
    { id: 6, name: "Təlimçilər", key: "teachers", icon: <TeachersIcon /> },
    {
      id: 7,
      name: "Təlimçilərin əməkhaqqı",
      key: "salaries",
      icon: <SalaryIcon />,
    },
    { id: 8, name: "Fənlər", key: "courses", icon: <CoursesIcon /> },
    { id: 9, name: "Sillabus", key: "syllabus", icon: <SyllabusIcon /> },
    { id: 10, name: "Qruplar", key: "groups", icon: <GroupIcon /> },
    {
      id: 11,
      name: "Rüblük hədəf planı",
      key: "quarterlyPlan",
      icon: <QuarterlyPlan />,
    },
    { id: 12, name: "Otaqlar", key: "room", icon: <RoomIcon /> },
    { id: 13, name: "Təhsil haqqı", key: "tuitionFee", icon: <ExpensesIcon /> },
    { id: 14, name: "Karyera", key: "career", icon: <CareerIcon /> },
    {
      id: 15,
      name: "Lead'lər",
      key: "consultation",
      icon: <MainPanelIcon />,
    },
    { id: 16, name: "Satış", key: "sales", icon: <SalesIcon /> },
    { id: 17, name: "Tədbirlər", key: "events", icon: <EventIcon /> },
    { id: 18, name: "Əməkdaşlar", key: "workers", icon: <AdminIcon /> },
    { id: 19, name: "Diploma Cədvəli", key: "diploma", icon: <DiplomaIcon /> },
    {
      id: 20,
      name: "Reklam növləri",
      key: "whereHeard",
      icon: <AdvertisingIcon />,
    },
    {
      id: 21,
      name: "Müqavilə növləri",
      key: "contracts",
      icon: <ContractTypeIcon />,
    },
    {
      id: 22,
      name: "Lead bölgüsü",
      key: "segmentation",
      icon: <ContractTypeIcon />,
    },
  ];

  const generalProfilePowerList = [
    {
      name: "Tam-səlahiyyətli",
      key: "all",
      infoList: [
        {
          key: "dashboard",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki İdarəetmə Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "report",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki Hesabatlar Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "lessonTable",
          info: "Tam-səlahiyyətli istifadəçilər Cədvəl səhifəsində bütün məlumatları görə bilir, Yeni dərs əlavə edə bilir, mövcud dərsi yeniləyə bilir və mövcud dərsi silə bilir.",
        },
        {
          key: "students",
          info: "Tam-səlahiyyətli istifadəçilər Tələbələr səhifəsində bütün məlumatları görə bilir, Yeni tələbə əlavə edə bilir, mövcud tələbəni yeniləyə bilir və mövcud tələbəni silə bilir.",
        },
        {
          key: "company",
          info: "Tam-səlahiyyətli istifadəçilər Şirkətlər səhifəsində bütün məlumatları görə bilir, Yeni Şirkət əlavə edə bilir, mövcud Şirkəti yeniləyə bilir.",
        },
        {
          key: "teachers",
          info: "Tam-səlahiyyətli istifadəçilər Müəllimlər səhifəsində bütün məlumatları görə bilir, Yeni müəllim əlavə edə bilir, mövcud müəllimi yeniləyə bilir və mövcud müəllimi silə bilir.",
        },
        {
          key: "salaries",
          info: "Tam-səlahiyyətli istifadəçilər əməkhaqqı səhifəsində bütün məlumatları görə bilir, təlimçilər üçün 1 dərs üçün olan ödənişi qeyd edə bilir.",
        },
        {
          key: "courses",
          info: "Tam-səlahiyyətli istifadəçilər Fənnlər səhifəsində bütün məlumatları görə bilir, Yeni fənn əlavə edə bilir, mövcud fənni yeniləyə bilir və mövcud fənni silə bilir.",
        },
        {
          key: "syllabus",
          info: "Tam-səlahiyyətli istifadəçilər Sillabus səhifəsində bütün məlumatları görə bilir, Yeni sillabus əlavə edə bilir, mövcud sillabusu yeniləyə bilir və mövcud sillabusdan məlumat silə bilir.",
        },
        {
          key: "groups",
          info: "Tam-səlahiyyətli istifadəçilər Qruplar səhifəsində bütün məlumatları görə bilir, Yeni qrup əlavə edə bilir, mövcud qrupu yeniləyə bilir və mövcud qrupu silə bilir.Qrup silinərkən, qrupda olan bütün dərslər də silinir. Həmçinin qrupda olan bütün tələbələrin bu qrupla bağlı məlumatları silinir. Ödənişlər də daxil olmaqla. Qrup yeniləndikdə çıxarılan tələbələrin bu qrup üçün olan məlumatları da silinir. Ödənişlər də daxil olmaqla. ",
        },
        {
          key: "room",
          info: "Tam-səlahiyyətli istifadəçilər Otaqlar səhifəsində bütün məlumatları görə bilir, Yeni otaq əlavə edə bilir, mövcud otaq məlumatlarını yeniləyə bilir və mövcud otaqı silə bilir.",
        },
        {
          key: "tuitionFee",
          info: "Tam-səlahiyyətli istifadəçilər Təhsil haqqı səhifəsində bütün məlumatları görə bilir, tələbə üçün edilmiş ödənişləri sadəcə təsdiqləyə bilir. Yeni ödəniş əlavə edə bilmir və ya silə bilmir ",
        },
        {
          key: "career",
          info: "Tam-səlahiyyətli istifadəçilər Karyera səhifəsində bütün məlumatları görə bilir və mövcud məlumatları yeniləyə bilir. Bu səhifədə yeni karyera əlavə etmək və ya silmək mümkün deyil. Məlumatlar tələbə məlumatlarından götürülür",
        },
        {
          key: "consultation",
          info: "Tam-səlahiyyətli istifadəçilər Lead səhifəsində bütün məlumatları görə bilir, yeni lead əlavə edə bilir, mövcud məlumatları yeniləyə bilir və silə bilir.",
        },
        {
          key: "sales",
          info: "Tam-səlahiyyətli istifadəçilər Satış səhifəsində bütün məlumatları görə bilir, yeni lead əlavə edə bilir, yeniləyə bilir və silə bilir.",
        },
        {
          key: "events",
          info: "Tam-səlahiyyətli istifadəçilər Tədbirlər səhifəsində bütün məlumatları görə bilir, yeni tədbir əlavə edə bilir, yeniləyə bilir və silə bilir.",
        },
        {
          key: "diploma",
          info: "Diploma səhifəsində bütün məlumatları görə bilir və yeniləyə bilir. Bu səhifədəki məlumatlar ümumiyyətlə silinə bilməz və yenisi əlavə edilə bilməz. Diploma məlumatları tələbə məlumatlarından götürülür.",
        },
        {
          key: "whereHeard",
          info: "Tam-səlahiyyətli istifadəçilər Reklam növləri səhifəsində bütün məlumatları görə bilir, yeni reklam növü əlavə edə bilir, yeniləyə bilir və silə bilir.",
        },
        {
          key: "contracts",
          info: "Tam-səlahiyyətli istifadəçilər Müqavilə növləri səhifəsində bütün məlumatları görə bilir, yeni müqavilə növü əlavə edə bilir və yeniləyə bilir",
        },
        {
          key: "segmentation",
          info: "Tam-səlahiyyətli istifadəçilər Lead bölgüsü səhifəsində bütün məlumatları görə bilir, yeni müqavilə növü əlavə edə bilir və yeniləyə bilir",
        },
      ],
    },
    {
      name: "Yarım-səlahiyyətli",
      key: "update",
      infoList: [
        {
          key: "dashboard",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki İdarəetmə Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "report",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki Hesabatlar Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "lessonTable",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "students",
          info: "Yarım-səlahiyyətli istifadəçilər Tələbələr səhifəsində bütün məlumatları görə bilir, Yeni tələbə əlavə edə bilir, mövcud tələbəni yeniləyə bilir. Lakin mövcud tələbəni silə bilməz. Yalnız tam-səlahiyyətli istifadəçi tələbəni silə bilər.",
        },
        {
          key: "teachers",
          info: "Yarım-səlahiyyətli istifadəçilər Müəllimlər səhifəsində bütün məlumatları görə bilir, Yeni müəllim əlavə edə bilir, mövcud müəllimi yeniləyə bilir. Lakin mövcud müəllimi silə bilməz. Yalnız tam-səlahiyyətli istifadəçi müəllimi silə bilər.",
        },
        {
          key: "salaries",
          info: "Yarım-səlahiyyətli istifadəçilər əməkhaqqı səhifəsində məlumatları yalnız görə bilir, heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "company",
          info: "Yarım-səlahiyyətli istifadəçilər Şirkətlər səhifəsində məlumatları yalnız görə bilir, heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "courses",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "syllabus",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "groups",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "room",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "tuitionFee",
          info: "Yarım-səlahiyyətli istifadəçilər Təhsil haqqı səhifəsində bütün məlumatları görə bilir, tələbə üçün yalnız ödəniş əlavə edə bilir və təsdiqlənməmiş ödənişləri silə bilir. Ödənişləri təsdiqləyə bilmir. Yalnız tam-səlahiyyətli istifadəçi ödənişləri təsdiqləyə bilər. Ödəniş təsdiqləndikdən sonra isə onu silə bilməz.",
        },
        {
          key: "career",
          info: "Məlumatları yalnız görə bilər və yeniləyə bilər.",
        },
        {
          key: "consultation",
          info: "Lead səhifəsində bütün məlumatları görə bilir, yeni lead əlavə edə bilir. Mövcud məlumatları yeniləyə və silə bilməz.",
        },
        {
          key: "sales",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "events",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "diploma",
          info: "Diploma səhifəsində bütün məlumatları görə bilir və yeniləyə bilir. Bu səhifədəki məlumatlar ümumiyyətlə silinə bilməz və yenisi əlavə edilə bilməz. Diploma məlumatları tələbə məlumatlarından götürülür.",
        },
        {
          key: "whereHeard",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "contracts",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "segmentation",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
      ],
    },
    {
      name: "Heç biri",
      key: "only-show",
      infoList: [
        {
          key: "dashboard",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki İdarəetmə Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "report",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz. Bu səhifədə bütün səlahiyyətlər eynidir. Çünki Hesabatlar Panelində məlumat əlavə edilmir, yenilənmir və silinmir. Sadəcə məlumatları göstərir.",
        },
        {
          key: "lessonTable",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "students",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "company",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "teachers",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "salaries",
          info: "məlumatları yalnız görə bilir, heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "courses",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "syllabus",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "groups",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "room",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "tuitionFee",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "career",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "consultation",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "sales",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "events",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "diploma",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "whereHeard",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "contracts",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
        {
          key: "segmentation",
          info: "Məlumatları yalnız görə bilər, lakin heç bir məlumat əlavə edə, yeniləyə və ya silə bilməz.",
        },
      ],
    },
  ];

  const careerModalWorkStatusList = [
    { name: "İşləyir", key: "employed" },
    { name: "Tələbədir", key: "student" },
    { name: "İşsizdir", key: "unemployed" },
  ];

  const diplomaDegrees = [
    { name: "Sertifikat", key: "certificate" },
    { name: "Adi diplom", key: "simple" },
    { name: "Şərəf diplomu", key: "honor" },
    { name: "Yoxdur", key: "none" },
  ];

  const diplomaStatus = [
    { name: "Yoxdur", key: "none" },
    { name: "Dizayna göndərilib", key: "send-design" },
    { name: "Dizayn olunub", key: "designed" },
    { name: "Çapa göndərildi", key: "send-print" },
    { name: "Akademiyadadır", key: "in-academy" },
    { name: "Diplom verilib", key: "awarded" },
  ];

  const studentStatus = [
    { key: "graduate", value: "Məzun" },
    { key: "continue", value: "Davam edir" },
    { key: "stopped", value: "Xitam" },
    { key: "freeze", value: "Dondurdu (Bunu artıq işlətmirik)" },
    { key: "waiting", value: "Yığılan" },
    { key: "debtor-graduate", value: "Borclu məzun" },
    { key: "transfer", value: "Transfer" },
  ];

  const tuitionStatusData = [
    { key: "waiting", name: "Yığılan" },
    { key: "continue", name: "Davam edir (Ümumi)" },
    { key: "graduate", name: "Məzun (Ümumi)" },
    { key: "stopped", name: "Xitam (Ümumi)" },
    { key: "freeze", name: "Dondurdu (Ümumi)" },
    { key: "transfer", name: "Transfer (Ümumi)" },
    { key: "debtor-graduate", name: "Borclu məzun" },
    { key: "debtor-continue", name: "Borclu davam edir" },
    { key: "debtor-freeze", name: "Borclu dondurdu (Bunu artıq işlətmirik)" },
    { key: "debtor-stopped", name: "Borclu xitam" },
  ];

  const notificationCategoriesList = [
    { key: "", name: "Bütün Kateqoriyalar" },
    { key: "student", name: "Tələbələr" },
    { key: "tuition-fee", name: "Təhsilhaqqı" },
    { key: "event", name: "Tədbirlər" },
    { key: "group", name: "Qruplar" },
  ];

  const contractTypesList = [
    { key: "B2B", name: "B2B" },
    { key: "B2C", name: "B2C" },
    { key: "B2C-Corporate", name: "B2C (Corporate sponsored)" },
    { key: "B2G", name: "B2G" },
    { key: "barter", name: "Barter" },
  ];

  const getWeeksBetweenDates = (start, end) => {
    let weeksList = [];
    const startDate = new Date(start);
    const endDate = new Date(end);
    let startWeek = new Date(startDate);
    let endWeek = new Date(startDate);

    if (endWeek.getDay() > 0) {
      endWeek.setDate(startDate.getDate() + (7 - startDate.getDay()));
    }

    const lastWeekEndDay = new Date(endDate);

    if (lastWeekEndDay.getDay() > 0) {
      lastWeekEndDay.setDate(
        lastWeekEndDay.getDate() + (7 - lastWeekEndDay.getDay()),
      );
    }
    lastWeekEndDay.setDate(lastWeekEndDay.getDate() + 1);

    while (lastWeekEndDay > endWeek) {
      weeksList.push({
        startWeek: startWeek.toString(),
        endWeek: endWeek.toString(),
        allWeekDays: {
          monday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 6),
          ).toString(),
          tuesday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 5),
          ).toString(),
          wednesday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 4),
          ).toString(),
          thursday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 3),
          ).toString(),
          friday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 2),
          ).toString(),
          saturday: new Date(
            new Date(endWeek).setDate(endWeek.getDate() - 1),
          ).toString(),
          sunday: endWeek.toString(),
        },
      });

      if (startWeek.getDay() === 0) {
        startWeek.setDate(startWeek.getDate() + 1);
      } else {
        startWeek.setDate(startWeek.getDate() + (8 - startWeek.getDay()));
      }

      endWeek.setDate(endWeek.getDate() + 7);
    }

    weeksList.at(-1).endWeek = endDate.toString();

    dispatch({
      type: WEEKS_BETWEEN_SELECTED_DATES_ACTION_TYPE.GET_SELECTED_DATES,
      payload: weeksList,
    });
  };
  const changeMainPageType = (type) => {
    dispatch({
      type: MAIN_PAGE_TYPE_ACTION_TYPE.GET_MAIN_PAGE_TYPE,
      payload: type,
    });
  };
  const createLessonModal = (data) => {
    dispatch({
      type: MODAL_LESSON_ACTION_TYPE.SET_MODAL_LESSON,
      payload: data,
    });
  };
  const clearLessonModal = () => {
    dispatch({
      type: MODAL_LESSON_ACTION_TYPE.SET_MODAL_LESSON,
      payload: { modalLesson: {}, openModal: false },
    });
  };
  const changeDropdownNameErr = (value) => {
    dispatch({ type: DROPDOWN_ERROR_TYPE.GET_DROPDOWN_ERROR, payload: value });
  };

  return {
    startWeek,
    endWeek,
    lessonHours,
    weeksArr,
    weeksArrFullName,
    fineTypeList,
    tuitionFeeHeadList,
    whereComingList,
    generalProfileList,
    generalProfilePowerList,
    paymentTypeList,
    discountReasonList,
    personaList,
    knowledgeList,
    cancelReasonList,
    constStatusList,
    lessonStatusList,
    whereSendList,
    careerModalWorkStatusList,
    getWeeksBetweenDates,
    changeMainPageType,
    createLessonModal,
    clearLessonModal,
    changeDropdownNameErr,
    diplomaDegrees,
    diplomaStatus,
    studentStatus,
    whereForDate,
    tuitionStatusData,
    salesTypeList,
    notificationCategoriesList,
    studentStatusList,
    contractTypesList,
    toBeConfirmedList,
  };
}
